import { render, staticRenderFns } from "./SISAlarm.vue?vue&type=template&id=26591128&scoped=true"
import script from "./SISAlarm.vue?vue&type=script&lang=js"
export * from "./SISAlarm.vue?vue&type=script&lang=js"
import style0 from "./SISAlarm.vue?vue&type=style&index=0&id=26591128&prod&lang=scss"
import style1 from "./SISAlarm.vue?vue&type=style&index=1&id=26591128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26591128",
  null
  
)

export default component.exports